import type { TNormalizedData } from "../types";

export const groupArrays = (
  arr: TNormalizedData,
): Record<string, string | number>[][] => {
  if (!arr.length) return [];
  const grouped: Record<string, string | number>[][] = [];
  for (let i = 0; i < arr[0].length; i++) {
    grouped.push(
      arr.map((row: Record<string, string>[]) => {
        if (i === 0) return row[i];
        const isNumber = !isNaN(Number.parseFloat(row[i]?.value));
        const value = isNumber ? Number(row[i].value) : 0;
        return { ...row[i], value };
      }),
    );
  }
  return grouped;
};
